import {useRef} from "react"

import {ChatbotEvent} from "@proto/chatbot/v1alpha/chatbot"
import {SPONSOR_TRIGGER, SponsorNetAPorter} from "@/constants"
import {useWebsocket} from "@/hooks/useWebsocket"
import {cn} from "@/lib/utils"
import {NetAPorterIcon} from "./icons"

interface IProps {
    message: string
}

const SelectMessage = ({message}: IProps) => {
    const {send, addMessage} = useWebsocket()
    const clicked = useRef(false)

    const sendMessage = (msg: string, display: string) => {
        if (!clicked.current) {
            const um: ChatbotEvent = {
                type: "user",
                message: msg,
                id: "",
                clientId: "",
            }
            send(JSON.stringify(um))

            const dm: ChatbotEvent = {
                type: "user",
                message: display,
                id: "",
                clientId: "",
            }
            addMessage(dm)

            clicked.current = true
        }
    }

    const selector = (index: number, key: string, val: string, sponsor: string) => {
        let classMode
        let clickable = true
        if (clicked.current) {
            classMode = "cursor-default"
            clickable = false
        } else {
            classMode = "cursor-pointer hover:bg-hover"
        }

        let prompt = val
        let sponsorIcon
        let msg = key
        if (key === "sponsor") {
            msg = SPONSOR_TRIGGER
            if (sponsor === SponsorNetAPorter) {
                prompt += " from "
                sponsorIcon = <NetAPorterIcon />
            }
        }

        let newline = false
        if (index % 2 > 0) {
            newline = true
        }

        return (
            <div key={index}>
                <div
                    onClick={clickable ? () => sendMessage(msg, val) : undefined}
                    className={cn(
                        "mb-[10px] ml-[10px] rounded-[28px] border-[0.5px] border-solid border-border bg-white p-[10px] pl-[15px] pr-[15px] text-center text-[14px] font-normal drop-shadow-[0_4px_4px_rgba(237,237,237,0.5)] sm:text-[16px]",
                        classMode,
                    )}
                >
                    {prompt}
                    {sponsorIcon}
                </div>
                {newline ? <div className=""></div> : undefined}
            </div>
        )
    }

    try {
        const sel = JSON.parse(message)

        return (
            <div className="flex flex-wrap justify-end sm:flex sm:place-content-center">
                {sel.options.map((opt: {key: string; value: string; sponsor: string}, i: number) => {
                    return selector(i, opt.key, opt.value, opt.sponsor)
                })}
            </div>
        )
    } catch (e) {
        return
    }
}

export default SelectMessage
